export default {
      id: "chassis_unloaded-usage",
      viewBox: "0 0 39 8",
      url: __webpack_public_path__ + "img/icons.svg#chassis_unloaded",
      toString: function () {
        return this.url;
      }
    }